<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="main-content">
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width: 100%;">
            <el-tab-pane key="stayUploadPhotoWarehouse" name="stayUploadPhotoWarehouse" :label="$t('CargoMsg.Cargo_PhotoShootingAwait')" :lazy="true">
              <stay-upload-photo-warehouse />
            </el-tab-pane>
            <el-tab-pane key="stayUploadPhotoLoading" name="stayUploadPhotoLoading" :label="$t('CargoMsg.Cargo_PhotoShootingAwaitPallets')" :lazy="true">
              <stay-upload-photo-loading />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stayUploadPhotoWarehouse from '@/views/cargo/v0/AirExport/components/stayUploadPhotoList/stayUploadPhotoWarehouse'
import stayUploadPhotoLoading from '@/views/cargo/v0/AirExport/components/stayUploadPhotoList/stayUploadPhotoLoading'

export default {
  name: 'StayUploadPhotoList',
  components: { stayUploadPhotoWarehouse, stayUploadPhotoLoading },
  data() {
    return {
      activeTabName: 'stayUploadPhotoWarehouse'
    }
  }
}
</script>
